import { handleActions } from 'redux-actions';
import { setActiveRecommendedSeats, toggleActiveRecommendedSeats } from './actions';
const initialState = false;
const activeRecommendedSeatsReducer = handleActions({
    [setActiveRecommendedSeats.toString()]: (_, { payload }) => payload,
    [toggleActiveRecommendedSeats.toString()]: state => !state
}, initialState);
export default activeRecommendedSeatsReducer;
